import { render, staticRenderFns } from "./PreviewImage.vue?vue&type=template&id=2dc29a64&scoped=true&"
import script from "./PreviewImage.vue?vue&type=script&lang=ts&"
export * from "./PreviewImage.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewImage.vue?vue&type=style&index=0&id=2dc29a64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc29a64",
  null
  
)

export default component.exports